import React from 'react';
import styles from './styles.module.scss';

export const Dashboard = ({ children }) => (
  <div className={styles.dashboard}>
    {children}
  </div>
);
